import React from 'react';
import format from 'string-template';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

const CashbackConditionComponent = ({ partner, i18n, BRAND_NAME }) => {
    if (partner) {
        let message = null;
        if (partner.conditions) {
            message = convertHtmlToReactDomWithParams(partner.conditions);
        } else {
            message = format(i18n.CONDITIONS_DEFAULT, partner.name, BRAND_NAME);
        }
        return message;
    }
    return null;
};

const CouponConditionComponent = ({ coupon }) => {
    if (coupon && coupon.description) {
        return <p>{convertHtmlToReactDomWithParams(coupon.description)}</p>;
    }
    return null;
};

export const ModalConditionsComponent = props => {
    return (
        <div className="metadata-conditions txtjustify">
            <CouponConditionComponent {...props} />
            <CashbackConditionComponent {...props} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalConditionsComponent.js